document.addEventListener('DOMContentLoaded', () => {
  const swiperEvent = setSwiperEvent();

  const uwb = new UWB({
    uaTabletViewport: {
      init: true,
      width: 1140,
    },
    toolStyleVariable100vh: {
      init: true,
      elementId: 'uw-styleVariable-100vh',
      variableName: '--js100vh', // CSS変数名
    },
    toolFixedHorizontalScroll: false,
  });
  
  const startFire = document.documentElement.clientHeight / 2;
  UWX.ScrollActionReferPosition('.service-header', startFire, {
    activeClass: 'fixed',
  });

  if(window.matchMedia('(max-width: 768px)').matches){
    const swiperAbout = setSwiperAbout();
    UWX.ScrollActionReferPosition('.follow-regist', startFire, {
      activeClass: 'active',
    });
  }
  
});

const setSwiperEvent = () => {
  return new Swiper('.sliderEvent', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 30,
    centeredSlides : true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

const setSwiperAbout = () => {
  return new Swiper('.sliderAbout', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 30,
    centeredSlides : true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}
